<div class="rs-row rs-row--stack">
  @if (heading) {
    <span class="rs-icon"><i class="bx bx-calendar-x"></i></span>
  }
  <div class="rs-text">
    @if (heading) {
      <span class="rs-row-title">{{ heading }}</span>
    }
    <span class="rs-row-desc" data-testid="closed-dates-copy"
      >A closed date closes the whole restaurant: no orders, bookings or walk-ins.{{
        offerSpecialHours ? ' Special hours replace the weekly booking hours for that date.' : ''
      }}
      Each change is saved right away.</span
    >

    @if (upcoming.length) {
      <ul class="rs-exceptions" data-testid="exceptions">
        @for (e of upcoming; track e.date) {
          <li class="rs-exception" [class.rs-exception--editing]="editingExceptionDate === e.date">
            <span class="rs-exception-date">{{ exceptionDateLabel(e.date) }}</span>
            <span
              class="rs-exception-what"
              [class.rs-exception-what--closed]="e.kind === 'closed'"
              >{{ exceptionSummary(e) }}</span
            >
            @if (e.note) {
              <span class="rs-exception-note">{{ e.note }}</span>
            }
            <span class="rs-exception-actions">
              <button type="button" class="rs-link" (click)="editException(e)">Edit</button>
              <button
                type="button"
                class="rs-link rs-link--danger"
                [disabled]="savingException"
                (click)="removeException(e)"
              >
                Remove
              </button>
            </span>
          </li>
        }
      </ul>
    } @else {
      <p class="rs-hint">
        {{
          showSpecialHours
            ? 'No closed dates or special hours coming up.'
            : 'No closed dates coming up.'
        }}
      </p>
    }

    <div class="rs-exception-form" [formGroup]="exceptionForm" data-testid="exception-form">
      <span class="rs-exception-form-title">{{
        editingExceptionDate ? 'Edit ' + exceptionDateLabel(editingExceptionDate) : 'Add a date'
      }}</span>
      <div class="rs-inline">
        <label
          >Date
          <input
            type="date"
            appPickerOnlyDate
            class="rs-input rs-input--date"
            formControlName="date"
            [min]="today"
            [max]="maxExceptionDate"
        /></label>
        @if (showSpecialHours) {
          <span class="rs-choice" role="radiogroup" aria-label="What happens that day">
            <label><input type="radio" formControlName="kind" value="closed" /> Closed</label>
            @if (offerSpecialHours || exceptionKind === 'hours') {
              <label
                ><input type="radio" formControlName="kind" value="hours" /> Special hours</label
              >
            }
          </span>
        }
      </div>

      @if (exceptionKind === 'hours') {
        <div class="rs-day-ranges" formArrayName="ranges">
          @for (r of exceptionRanges.controls; track r; let j = $index) {
            <span class="rs-range" [formGroup]="asGroup(r)">
              <input
                type="time"
                class="rs-input rs-input--time"
                formControlName="start_time"
                step="900"
                aria-label="Bookings from"
              />
              <span class="rs-band-label">to</span>
              <input
                type="time"
                class="rs-input rs-input--time"
                formControlName="end_time"
                step="900"
                aria-label="Bookings until"
              />
              @if (exceptionRanges.length > 1) {
                <button
                  type="button"
                  class="rs-x"
                  (click)="removeExceptionRange(j)"
                  aria-label="Remove these hours"
                >
                  <i class="bx bx-x"></i>
                </button>
              }
            </span>
          }
          <button type="button" class="rs-link" (click)="addExceptionRange()">
            <i class="bx bx-plus"></i> Add hours
          </button>
        </div>
      }

      <label class="rs-note-label"
        ><span class="rs-note-title">Note <span class="rs-optional">optional</span></span>
        <input
          type="text"
          class="rs-input rs-input--note"
          formControlName="note"
          maxlength="60"
          placeholder="e.g. Christmas, Private event"
          (keydown.enter)="$event.preventDefault(); saveException()"
      /></label>
      <p class="rs-hint" data-testid="note-public">
        <i class="bx bx-show" aria-hidden="true"></i>
        Guests may see this note, for example "Closed: Christmas".
      </p>

      @if (replacesSpecialHours) {
        <p class="rs-hint rs-hint--warn" role="status" data-testid="replaces-special-hours">
          <i class="bx bx-error-circle" aria-hidden="true"></i>
          That date has special booking hours, set in Reservation settings. Closing it replaces
          them.
        </p>
      }

      @if (exceptionKind === 'closed' && bookingsOnDate) {
        <p class="rs-hint rs-hint--warn" role="status" data-testid="bookings-on-date">
          <i class="bx bx-error-circle" aria-hidden="true"></i>
          {{ bookingsOnDate }}
          {{ bookingsOnDate === 1 ? 'booking is' : 'bookings are' }}
          already on this date. They stay booked; let those guests know.
          <a
            class="rs-inline-link"
            routerLink="/main/reservation"
            [queryParams]="{ date: exceptionForm.get('date')!.value }"
            >Open the book for that day</a
          >
        </p>
      }

      @if (exceptionForm.touched && exceptionError) {
        <p class="rs-field-error" role="alert">{{ exceptionError }}</p>
      }

      <div class="rs-exception-buttons">
        <button
          type="button"
          class="rs-save rs-save--sm"
          [disabled]="savingException || !!exceptionError"
          (click)="saveException()"
        >
          {{ editingExceptionDate ? 'Save date' : 'Add date' }}
        </button>
        @if (editingExceptionDate) {
          <button type="button" class="rs-link" (click)="cancelException()">Cancel</button>
        }
      </div>
    </div>
  </div>
</div>
